import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "./Breadcrumb";

interface PageHeaderProps {
  crumbs: Crumb[];
  title: string;
  lead?: string;
  children?: ReactNode;
}

export default function PageHeader({ crumbs, title, lead, children }: PageHeaderProps) {
  return (
    <header className="border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 pb-10 pt-28 md:px-6 md:pb-14 md:pt-36">
        <Breadcrumb items={crumbs} />
        <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl lg:text-5xl">
          {title}
        </h1>
        {lead && (
          <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {lead}
          </p>
        )}
        {children && <div className="mt-6">{children}</div>}
      </div>
    </header>
  );
}